<template>
  <ion-page class="test-result">
    <div class="test-result_content">
      <div v-if="!externalSource" class="test-result_header">
        <i class="iconfont icon-back test-result_header-back" @click="routerBack"></i>
        <div class="test-result_header-title">词汇测试记录</div>
        <img src="@/assets/share.png" class="test-result_header-share" alt="" @click="saveImage" />
      </div>
      <div class="test-result_time" :style="[externalSource ? 'margin-top: 2rem' : '']">
        测试时间：{{ dayjs(detail.createTime).format("YYYY/MM/DD") }}
      </div>
      <div class="test-result_card">
        <div class="test-result_line">
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
        </div>
        <img src="@/assets/report/tag.png" class="test-result_card-tag" alt="" />
        <img src="@/assets/report/user.png" class="test-result_card-user" alt="" />
        <div class="test-result_user">
          <div class="detail-username">{{ detail.username }}</div>
          <img class="detail-avatar" :src="detail.avatar" alt="" />
        </div>
        <div class="test-result_common">
          <div v-if="detail.tryInfoGrade" class="test-result_info">
            年级：{{ detail.tryInfoGrade }}
          </div>
          <div v-if="detail.tryInfoGrade" class="bar"></div>
          <div v-if="detail.age" class="test-result_info">年龄：{{ detail.age }}</div>
        </div>
        <div class="test-result_info">机构：{{ detail.schoolName }}</div>
      </div>
      <div class="test-result_card">
        <div class="test-result_line">
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
        </div>
        <div class="test-result_level-title">
          {{ detail.ability.replace("水平", "").replace("或", "") }}
        </div>
        <div class="test-result_level-tip">{{ detail.username }} 你的词汇量约为</div>
        <div class="test-result_level-num">
          {{ detail.vocabulary || 0 }}<span class="test-result_level-unit">词</span>
        </div>
        <div class="test-result_level-common">
          相当于<span class="test-result_level-ability">{{ detail.ability }}</span>
        </div>
        <img src="@/assets/report/result.png" class="test-result_level-bg" alt="" />
      </div>
      <div class="test-result_card">
        <div class="test-result_line">
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
        </div>
        <div class="test-result_title">语言水平分级</div>
        <div class="test-result_chart">
          <img src="@/assets/report/chart.png" class="test-result_chart-bg" alt="" />
          <img
            src="@/assets/report/pin.png"
            class="test-result_chart-pin"
            :class="[`level${detail.level}`]"
            alt=""
          />
        </div>
      </div>
      <div class="test-result_card">
        <div class="test-result_line">
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
        </div>
        <div class="test-result_title">词量对比</div>
        <div class="test-result-bar">
          <div v-for="item in barNumList" :key="item" class="test-result-bar_layer">
            <div class="test-result-bar_num">{{ item }}</div>
          </div>
          <div class="test-result-bar_values">
            <div v-for="(item, index) in currentBarValue" :key="item" class="test-result-bar_value">
              <div
                class="test-result-bar_value-value"
                :style="{
                  height: currentBarHeight[index],
                }"
              >
                <div class="test-result-bar_value-label">{{ item }}</div>
              </div>
            </div>
          </div>
          <div class="test-result-bar_labels">
            <div v-for="item in currentBarLabel" :key="item" class="test-result-bar_label">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="test-result_card">
        <div class="test-result_line">
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
          <img src="@/assets/report/line.png" class="test-result_line-line" alt="" />
        </div>
        <div class="test-result_suggestion">
          <div class="test-result_suggestion-title">语言能力评估</div>
          <div class="test-result_suggestion-content">{{ detail.description }}</div>
        </div>
        <div class="test-result_suggestion">
          <div class="test-result_suggestion-title">评测分析</div>
          <div class="test-result_suggestion-content">{{ detail.evaluation }}</div>
        </div>
        <div class="test-result_suggestion">
          <div class="test-result_suggestion-title">训练建议</div>
          <div class="test-result_suggestion-content">{{ detail.suggestion }}</div>
        </div>
      </div>
      <div class="test-result_card">
        <div class="test-result_title">训练单词</div>
        <div class="test-result_words">
          <div v-for="(item, index) in dataList" :key="index" class="test-result_word">
            <div class="test-result_word-title">
              <span class="test-result_word-index">{{ index + 1 }}.</span>
              <span class="test-result_word-en">{{ item.word }}</span>
              <span class="test-result_word-cn">{{ item.paraphrase }};</span>
              <img
                v-if="item.myAnswer && item.myAnswer === item.answer"
                src="@/assets/check_mark_icon.png"
                alt=""
                class="test-result_word-icon"
              />
            </div>

            <div v-if="item.myAnswer !== item.answer" class="test-result_wrong">
              <div class="test-result_wrong-correct">
                <span class="label-correct">正确选项:</span>
                <span class="word">{{ item.word }}</span>
                <span class="cn">{{ item.paraphrase }}</span>
              </div>
              <div class="test-result_wrong-my">
                <span class="label-my">你的选项:</span>
                <span class="word">{{ item.word }}</span>
                <span class="cn">{{ item.myParaphrase }}</span>
                <img src="@/assets/false_mark_icon.png" alt="" class="wrong-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { IonPage, modalController } from "@ionic/vue"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import dayjs from "dayjs"
import unKnown from "@/assets/teacher_index/version5/unknown_gender.png"
import html2canvas from "html2canvas"
import maleStudent from "@/assets/teacher_index/version5/male_student.png"
import femaleStudent from "@/assets/teacher_index/version5/female_student.png"

export default {
  name: "VocabularyTestResult",
  components: {
    IonPage,
  },
  props: ["testId"],
  setup() {
    return {}
  },
  data() {
    return {
      styleHeight: "height:21.6VW",
      detail: {
        createTime: undefined,
        vocabulary: 0,
        ability: "",
        description: "",
        suggestion: "",
        evaluation: "",
        level: 1,
        tryInfoGrade: "",
        age: "",
      },
      brandImages: BRAND_IMAGES,
      barNumList: [7000, 5600, 4200, 2800, 1400, 0],
      barLabelMap: {
        1: ["儿童高级", "儿童中级", "儿童初级", "您的测试词汇量"],
        2: ["儿童高级", "儿童中级", "儿童初级", "您的测试词汇量"],
        3: ["儿童高级", "儿童中级", "儿童初级", "您的测试词汇量"],
        4: ["少年高级", "少年中级", "少年初级", "您的测试词汇量"],
        5: ["少年高级", "少年中级", "少年初级", "您的测试词汇量"],
        6: ["少年高级", "少年中级", "少年初级", "您的测试词汇量"],
        7: ["青少年高级", "青少年中级", "青少年初级", "您的测试词汇量"],
        8: ["青少年高级", "青少年中级", "青少年初级", "您的测试词汇量"],
        9: ["青少年高级", "青少年中级", "青少年初级", "您的测试词汇量"],
        10: ["雅思托福高级", "雅思托福中级", "雅思托福初级", "您的测试词汇量"],
        11: ["雅思托福高级", "雅思托福中级", "雅思托福初级", "您的测试词汇量"],
        12: ["雅思托福高级", "雅思托福中级", "雅思托福初级", "您的测试词汇量"],
      },
      currentBarLabel: [],
      barValueMap: {
        1: [540, 360, 180],
        2: [540, 360, 180],
        3: [540, 360, 180],
        4: [1575, 1190, 845],
        5: [1575, 1190, 845],
        6: [1575, 1190, 845],
        7: [3420, 2635, 2080],
        8: [3420, 2635, 2080],
        9: [3420, 2635, 2080],
        10: [6500, 5520, 4305],
        11: [6500, 5520, 4305],
        12: [6500, 5520, 4305],
      },
      currentBarValue: [],
      currentBarHeight: [],
      externalSource: false,
      currentTestId: "",
      // 新增：训练单词列表
      dataList: [],
    }
  },
  created() {
    if (this.$route.query && this.$route.query.source) {
      this.externalSource = this.$route.query.source === "external"
    }
    if (this.$route.query && this.$route.query.testId) {
      this.currentTestId = this.$route.query.testId
    }
  },
  mounted() {
    if (this.testId) {
      this.currentTestId = this.testId
    }
    this.queryTestResult()
  },

  methods: {
    dayjs,
    getBrandImageUrl,
    routerBack() {
      modalController.dismiss()
    },
    async saveImage() {
      try {
        // 1. 获取要导出的 DOM 元素
        var contentEl = document.querySelector(".test-result_content")
        var originalScrollTop = contentEl.scrollTop
        var originalOverflow = contentEl.style.overflow

        // 2. 临时禁用滚动，确保完整渲染
        contentEl.style.overflow = "visible"
        contentEl.style.background =
          "linear-gradient(180deg, #69d1ab 0%, #93c7c2 50%, #b4bdd1 100%) fixed"
        contentEl.style.backgroundSize = "100% 100%"

        // 3. 预加载所有图片（避免图片未加载完成导致空白）
        await this.preloadImages()

        // 4. 计算完整尺寸
        const fullWidth = contentEl.scrollWidth
        const fullHeight = contentEl.scrollHeight

        // 5. 创建 Canvas 并设置高清分辨率
        const canvas = document.createElement("canvas")
        const scale = 2 // 提高导出图片清晰度
        canvas.width = fullWidth * scale
        canvas.height = fullHeight * scale
        const ctx = canvas.getContext("2d")

        // 6. 配置 html2canvas 选项
        const options = {
          scale: scale,
          width: fullWidth,
          height: fullHeight,
          scrollX: 0,
          scrollY: 0,
          useCORS: true, // 允许跨域图片
          allowTaint: true, // 允许渲染外部图片
          backgroundColor: null, // 禁用默认白色背景（使用你的渐变）
          logging: false, // 关闭调试日志
          onclone: (clonedDoc) => {
            // 确保克隆的 DOM 也有正确的背景
            const clonedContent = clonedDoc.querySelector(".test-result_content")
            clonedContent.style.background =
              "linear-gradient(180deg, #69d1ab 0%, #93c7c2 50%, #b4bdd1 100%) fixed"
            clonedContent.style.backgroundSize = "100% 100%"
          },
        }

        // 7. 渲染 DOM 到 Canvas
        const canvasResult = await html2canvas(contentEl, options)

        // 8. 手动绘制渐变背景（确保覆盖整个 Canvas）
        const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height)
        gradient.addColorStop(0, "#69d1ab")
        gradient.addColorStop(0.5, "#93c7c2")
        gradient.addColorStop(1, "#b4bdd1")
        ctx.fillStyle = gradient
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(canvasResult, 0, 0, canvas.width, canvas.height)

        // 9. 导出为 PNG
        const link = document.createElement("a")
        link.download = "测试记录_" + new Date().toLocaleString().replace(/[/:]/g, "-") + ".png"
        link.href = canvas.toDataURL("image/png", 1.0) // 最高质量
        link.click()
      } catch (error) {
        console.error("导出图片失败:", error)
        alert("导出图片失败，请重试或检查控制台错误。")
      } finally {
        // 10. 恢复原始样式
        if (contentEl) {
          contentEl.style.overflow = originalOverflow
          contentEl.scrollTop = originalScrollTop
        }
      }
    },

    // 辅助方法：预加载所有图片
    preloadImages() {
      return Promise.all(
        Array.from(document.querySelectorAll("img")).map((img) => {
          if (img.complete) return Promise.resolve()
          return new Promise((resolve, reject) => {
            img.onload = resolve
            img.onerror = reject
          })
        })
      )
    },
    queryTestResult() {
      this.ajax
        .get("/vocabulary/queryTestResultDetail?testId=" + this.currentTestId)
        .then((res) => {
          if (res.data.success) {
            this.detail = res.data.data
            this.detail.description = res.data.description
            this.detail.suggestion = res.data.suggestion
            this.detail.evaluation = res.data.evaluation
            this.currentBarLabel = this.barLabelMap[this.detail.level]
            this.currentBarValue = this.barValueMap[this.detail.level]
            this.currentBarValue.push(this.detail.vocabulary)
            this.currentBarHeight = this.currentBarValue.map((item) => {
              return (item / 7000) * 15 + "rem"
            })
            if (!this.detail.avatar) {
              this.getUserAvatar()
            }
            // 新增：在详情加载完成后加载训练单词列表
            this.queryTestWords(res.data.details)
          }
        })
    },
    getUserAvatar() {
      if (this.detail.sex === 1) {
        if (this.detail.userType === 1) {
          this.detail.avatar = maleStudent
        } else {
          this.detail.avatar = getBrandImageUrl("class_record/user_avatar_1.png")
        }
      } else if (this.detail.sex === 2) {
        if (this.detail.userType === 1) {
          this.detail.avatar = femaleStudent
        } else {
          this.detail.avatar = getBrandImageUrl("class_record/user_avatar.png")
        }
      } else {
        this.detail.avatar = unKnown
      }
    },
    // 新增：选项转中文释义
    getOption(answer, obj) {
      switch (answer) {
        case 1:
          return obj.option1
        case 2:
          return obj.option2
        case 3:
          return obj.option3
        case 4:
          return obj.option4
        case 5:
          return obj.option5
      }
    },
    // 新增：查询训练单词列表
    queryTestWords(details) {
      this.dataList = details || []
      // 计算正确释义与我的释义
      for (let i = 0; i < this.dataList.length; i++) {
        const it = this.dataList[i]
        it.paraphrase = this.getOption(it.answer, it)
        if (it.myAnswer) {
          it.myParaphrase = this.getOption(it.myAnswer, it)
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.test-result_content {
  height: 100%;
  background: linear-gradient(180deg, #69d1ab 0%, #93c7c2 50%, #b4bdd1 100%) fixed;
  background-size: 100% 100%; /* 确保渐变覆盖整个区域 */
  padding: 0 1rem 2rem;
  overflow-y: auto;
}

.test-result_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5.5rem;
  padding: 1rem 0;
  position: relative;

  &-back {
    font-size: 2.5rem;
    cursor: pointer;
  }

  &-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5rem;
    font-weight: 600;
    color: #1e2023;
  }

  &-share {
    cursor: pointer;
    height: 2.5rem;
    width: 2.5rem;
  }
}

.test-result_time {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #3f4140;
  margin-bottom: 2rem;
}

.test-result_card {
  background: #ffffff;
  border-radius: 1rem;
  margin-top: 1rem;
  padding: 1.5rem 1rem;
  position: relative;
}

.test-result_line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: -2rem;
  width: calc(100% - 4rem);
  left: 2rem;
  z-index: 999;

  &-line {
    height: 3rem;
  }
}

.test-result_suggestion {
  border-bottom: 1px solid #01413c33;
  margin-top: 1.5rem;

  &:last-child {
    border: none;
  }

  &-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #1e2023;
  }

  &-content {
    margin: 1rem 0 1.5rem;
    font-size: 1rem;
    color: #3f4140;
  }
}

.test-result_card-tag {
  position: absolute;
  left: 1rem;
  top: -1rem;
  width: 4.5rem;
  z-index: 9;
}

.test-result_card-user {
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.test-result_user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  .detail-username {
    font-size: 1.5rem;
    font-weight: 500;
    color: #1e2023;
  }

  .detail-avatar {
    height: 4.5rem;
    width: 4.5rem;
    border-radius: 50%;
    flex-shrink: 0;
    margin-left: 0.5rem;
  }
}

.bar {
  width: 0.1rem;
  background: #874a1a;
  height: 1rem;
  margin: 0.3rem 1rem 0;
}

.test-result_common {
  display: flex;
}

.test-result_info {
  color: #874a1a;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 400;
}

.test-result_level {
  &-title {
    background: url("@/assets/report/title_bg.png") no-repeat 0 0 / 100% 100%;
    width: calc(100% - 12.5rem);
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    position: absolute;
    color: #ffffff;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    font-weight: bold;
  }

  &-tip {
    font-size: 1.1rem;
    margin-top: 3rem;
    color: #111111;
    text-align: center;
  }

  &-num {
    color: #fe5901;
    font-size: 2.5rem;
    font-weight: bold;
    text-align: center;
  }

  &-unit {
    color: #fe5901;
    font-size: 1rem;
    font-weight: 400;
  }

  &-common {
    color: #111111;
    font-size: 1rem;
    text-align: center;
    margin-bottom: 0.5rem;
  }

  &-ability {
    color: #fe5901;
    font-size: 1.2rem;
    font-weight: bold;
  }

  &-bg {
    height: 6rem;
    width: 6rem;
    position: absolute;
    bottom: 2rem;
    right: 1rem;
  }
}

.test-result_title {
  font-size: 1.2rem;
  color: #0c514c;
  font-weight: 500;
  margin: 0.5rem 0 1rem;
}

.test-result_chart {
  height: 15rem;
  width: 100%;
  position: relative;

  &-bg {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 9;
  }

  &-pin {
    position: absolute;
    height: 1rem;
  }

  .level1 {
    left: 70%;
    top: 13.7rem;
  }

  .level2 {
    left: 70%;
    top: 12.5rem;
  }

  .level3 {
    left: 70%;
    top: 11.3rem;
  }

  .level4 {
    left: 67%;
    top: 10rem;
  }

  .level5 {
    left: 67%;
    top: 8.8rem;
  }

  .level6 {
    left: 67%;
    top: 7.6rem;
  }

  .level7 {
    left: 63%;
    top: 6.3rem;
  }

  .level8 {
    left: 63%;
    top: 5.1rem;
  }

  .level9 {
    left: 63%;
    top: 3.9rem;
  }

  .level10 {
    left: 55%;
    top: 2.6rem;
  }

  .level11 {
    left: 55%;
    top: 1.3rem;
  }

  .level12 {
    left: 55%;
    top: 0.1rem;
  }
}

.test-result-bar {
  height: 18rem;
  padding: 0 1rem 0 3rem;
  position: relative;

  &_layer {
    height: 3rem;
    border-top: 0.01rem dashed #dde1de;
    position: relative;
  }

  &_num {
    width: 3rem;
    height: 1rem;
    position: absolute;
    left: -3rem;
    top: -0.6rem;
    font-size: 1rem;
    color: #868686;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 0.4rem;
  }

  &_labels {
    position: absolute;
    left: 3rem;
    bottom: 0;
    display: flex;
    align-items: center;
    height: 3rem;
    width: calc(100% - 4rem);
  }

  &_label {
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #111111;
    font-size: 0.8rem;
    text-align: center;

    &:last-child {
      color: #ffad00;
    }
  }

  &_values {
    position: absolute;
    left: 3rem;
    top: 0;
    width: calc(100% - 4rem);
    height: calc(100% - 3rem);
    display: flex;
  }

  &_value {
    width: 25%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    &-value {
      height: 10rem;
      width: 70%;
      background: #2aa8da;
      border-radius: 0.3rem;
      position: relative;
    }

    &-label {
      position: absolute;
      left: 50%;
      top: -1.5rem;
      transform: translateX(-50%);
      color: #111111;
      font-size: 1rem;
    }

    &:last-child {
      .test-result-bar_value-value {
        background: #ffad00;
      }

      .test-result-bar_value-label {
        color: #e59c00;
      }
    }
  }
}

/* 训练单词与错误答案样式 */
.test-result_words {
  margin-top: 0.5rem;
  & > div:not(:last-child) {
    border-bottom: 1px solid #efefef;
  }
}

.test-result_word {
  padding: 0.8rem 0;
}

.test-result_word-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-word;
  font-size: 1rem;
  color: #1e2023;
}

.test-result_word-index {
  margin-right: 0.2rem;
  color: #9a9b9c;
}

.test-result_word-en {
  font-size: 1.3rem;
  font-weight: 600;
  margin-right: 0.5rem;
}

.test-result_word-cn {
  color: #9a9b9c;
  flex: 1;
}

.test-result_word-icon {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  width: 1.7rem;
}

/* 错误答案区块 */
.test-result_wrong {
  margin-top: 0.5rem;
  color: #1e2023;
  .word {
    font-weight: 600;
    font-size: 1.3rem;
  }
}

.test-result_wrong-correct {
  border-radius: 0.5rem 0.5rem 0 0;
  padding: 0.8rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-word;
  gap: 0.5rem;
  background-color: #fafafa;
  .label-correct {
    color: #0dcb8b;
  }
  .cn {
    color: #9a9b9c;
  }
}

.test-result_wrong-my {
  background: rgba(255, 50, 57, 0.1);
  border-radius: 0 0 0.5rem 0.5rem;
  padding: 0.8rem;
  display: flex;
  flex-wrap: wrap;
  word-break: break-word;
  gap: 0.5rem;
  align-items: center;
  position: relative;
  .label-my {
    color: #299fe5;
  }
  .cn {
    color: #ff524d;
  }
}

.wrong-icon {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.7rem;
}
</style>
